export const TERMINAL_DEF_GET = "/TerminalDef/GetAllTerminalDef"